import React from "react";
import { z } from "zod";
import { Button, Col, Container, Row, Form } from "shared-portal-component";

import { setDraftField, setShowSuccessScreen, setStep } from "@/store/slices/createSix/createSixSlice";
import { useAppDispatch } from "@/store";

const MIN = 1
// Zod schema for validation
const schema = z.object({
  name: z.string().min(MIN, "Name is required"),
  email: z.string().email("Valid email required"),
  phoneNumber: z.string().min(MIN, "Phone number is required"),
});

const fields = [
  {
    name: "name",
    placeholder: "Full name",
    required: true,
    type: "text",
    label: "External User’s Name"
  },
  {
    name: "email",
    placeholder: "Email address",
    required: true,
    type: "email",
    label: "External User's Email"
  },
  {
    name: "phoneNumber",
    placeholder: "Phone number",
    required: true,
    type: "phone",
    label: "External User's Phone Number"
  },
  {
    name: "department",
    placeholder: "Department",
    required: false,
    type: "text",
    label: "External User's Department"
  },
];

interface StepInviteExternalProps {
  onClose: () => void;
}
const StepInviteExternal: React.FC<StepInviteExternalProps> = () => {
  const dispatch = useAppDispatch();

  const handleSubmit = (values: { name: string; email: string; phoneNumber: string, department?: string }) => {
    dispatch(setDraftField({
      key: "newExternalUsers",
      value: [{ ...values }],
    }));
    dispatch(setShowSuccessScreen(true));
  };

  const handleBack = () => dispatch(setStep("ExternalParticipants"));

  return (
         <Container fluid>
        <Row spacing="md" justify="center"   >
            <Col md={7} sm={10} xs={12}>
    <Form
      schema={schema}
      fields={fields}
      onSubmit={handleSubmit}
      secondaryButton={
        <Button  size="md" className="form-button" onClick={handleBack} text="Go Back" />
      }
    />
    </Col>
    </Row>
      </Container>
  );
};

export default StepInviteExternal;
